import { createFileRoute } from '@tanstack/react-router';
import { DepositEditor } from '../../components/deposits/DepositEditor';
import { useActiveCompanyId } from '../../stores/useCompanyStore';

export const Route = createFileRoute('/_auth/deposits/$id_/edit')({
  component: EditDepositPage,
});

function EditDepositPage() {
  const { id } = Route.useParams();
  const companyId = useActiveCompanyId();

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <p className="muted">No active company.</p>
      </div>
    );
  }

  return <DepositEditor companyId={companyId} editId={id} />;
}
